module.exports = __webpack_public_path__ + "static/img/snip3down.6d04b95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/snip3down.jpg
// module id = EpR/
// module chunks = 35